<template>
  <div>
  
      <v-toolbar flat>
        <v-toolbar-title class="grey--text">
          <img style="height:50px"
            :src="require(`../assets/images/${$vuetify.theme.dark ? 'logo-mini' : 'logo-mini-dark'}.png`)">
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn :key="$vuetify.theme.dark" @click="$vuetify.theme.dark = !$vuetify.theme.dark" class="ma-2" large small
          icon>
          <v-icon :class="$vuetify.theme.dark? 'white--text' :'black--text'">
            {{ $vuetify.theme.dark ? "brightness_2" : "wb_sunny" }}
          </v-icon>
        </v-btn>

        <v-btn class="ma-2" rounded @click="goDashboard1()" color="primary">
          BUY
        </v-btn>

      </v-toolbar>
       <v-container>
        <v-row class="text-center mb-15 ">
          <v-col cols="12" lg="12" xl="12">
            <v-img :src="require(`../assets/images/${$vuetify.theme.dark ? 'logo-light' : 'logo-dark'}.png`)"
              class="mt-15" contain height="200" />
          </v-col>

          <v-col cols="12" lg="12" xl="12">
            <h1 class="display-2 text-decoration-underline font-weight-bold mb-3 mt-n12">
              A trusted and secure </br>cryptocurrency exchange.
            </h1>

            <p class="text-h6  font-weight-thin">
              Corebot is the most advanced Vue Admin for making the Blockchain platform.
            </p>
          </v-col>

          <v-col class="mb-5" cols="12">


            <v-row justify="center">

              <v-col cols="6">
                <v-btn rounded @click="goDashboard1()" color="primary" dark>
                  Get Start
                </v-btn>
              </v-col>

            </v-row>

          </v-col>


        </v-row>
      </v-container>
      <card-slider></card-slider>
      <v-container class="transparent mb-15">
        <v-row class="text-center mb-15 ">


          <v-col class="text-center mt-15">
            <h1 class="display-2 text-decoration-underline  mb-3 mt-n12">
              Demo
            </h1>
            <p class="text-h6  font-weight-thin">
              Vue Cryptocurrency Dashboard Template
            </p>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" sm="6">
            <v-card class="pa-2 ma-3 " outlined tile>
              <v-system-bar dark color="black darken-2">
                <v-spacer></v-spacer>
                <v-icon>mdi-wifi-strength-4</v-icon>
                <v-icon>mdi-signal-cellular-outline</v-icon>
                <v-icon>mdi-battery</v-icon>
                <span>12:30</span>
              </v-system-bar>
              <v-img :aspect-ratio="16/9" :width="width"
                :src="require(`../assets/images/home/dash1-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)">
              </v-img>
              <v-btn @click="goDashboard1()" color="primary" block>
                Dashboard 1
              </v-btn>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card class="pa-2 ma-3" outlined tile>
              <v-system-bar dark color="black darken-2">
                <v-spacer></v-spacer>
                <v-icon>mdi-wifi-strength-4</v-icon>
                <v-icon>mdi-signal-cellular-outline</v-icon>
                <v-icon>mdi-battery</v-icon>
                <span>12:30</span>
              </v-system-bar>
              <v-img :aspect-ratio="16/9" :width="width"
                :src="require(`../assets/images/home/dash2-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)">
              </v-img>
              <v-btn @click="goDashboard2()" color="primary" block>
                Dashboard2
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-row no-gutters>

        <card-coin></card-coin>

      </v-row>


      <v-parallax dark :src="require(`../assets/images/bg/${$vuetify.theme.dark ? 'bg-dark' : 'bg-light'}.png`)">
        <v-row align="center" justify="center">
          <v-col class="text-center" cols="12">
            <h1 color="primary" class="text-h4 primary--text font-weight-thin mb-4">
              COREBOT
            </h1>
            <h4 color="primary" class="primary--text subheading">
              Vue Cryptocurrency Dashboard Template
            </h4>
          </v-col>
        </v-row>
      </v-parallax>

      <card-orderbook></card-orderbook>
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <card-slide-group></card-slide-group>
        </v-col>

      </v-row>

    <v-footer dark padless>
      <v-card class="flex" flat tile>
        <v-card-title>
          <strong class="subheading">Get connected with us on social networks!</strong>

          <v-spacer></v-spacer>

          <v-btn v-for="icon in icons" :key="icon" class="mx-4" dark icon>
            <v-icon color="primary" size="24px">
              {{ icon }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="py-2  text-center">
          {{ new Date().getFullYear() }} — <strong>CoreBot Vue Crypto Template</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
  import CardSlider from '../components/Cards/CardSlider'
  import CardCoin from '../components/Cards/CardCoin'
  import BaseCard from '../components/Base/BaseCard'
  import CardSlideGroup from '../components/Cards/CardSlideGroup'
  import CardOrderbook from '../components/Cards/CardOrderbook'
  export default {
    name: 'Home',

    components: {
      CardSlider,
      CardSlideGroup,
      CardCoin,
      BaseCard,
      CardOrderbook,

    },
    data: () => ({
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-linkedin',
        'mdi-instagram',
      ],
      width: 550,
      model: null,
      selectedItem: 1,
      items: [{
          text: 'Real-Time',
          icon: 'done_outline'
        },
        {
          text: 'Audience',
          icon: 'done_outline'
        },
        {
          text: 'Dashboard',
          icon: 'done_outline'
        }, {
          text: 'Wallet',
          icon: 'done_outline'
        },
        {
          text: 'Market',
          icon: 'done_outline'
        }, {
          text: 'Trader',
          icon: 'done_outline'
        },
      ],
    }),
    methods: {
      goDashboard1() {
        return this.$router.push("/dashboard/dashboard1");
      },
      goDashboard2() {
        return this.$router.push("/dashboard/dashboard2");
      },
    },

  }
</script>